import { AlertConfiguration, AlertConfigurationByState, DeviceAlertComparisonType, DeviceAlertMetricName } from "@/__generated__/graphql";
import { getUnit } from "./units";
import { t } from "@lingui/macro";
import { type I18n } from '@lingui/core';

const alertConfigurationStateToString = (state: AlertConfigurationByState, i18n: I18n): string => {
  if (state.metricUnit == null) {
    throw new Error('Metric unit is required to format the state representation');
  }
  switch (state.comparisonType) {
    case DeviceAlertComparisonType.InsideRange:
      return t(i18n)`Dentro del rango ${state.thresholdMin}-${state.thresholdMax} ${getUnit(state.metricUnit, i18n)?.short}`;
    case DeviceAlertComparisonType.OutsideRange:
      return t(i18n)`Fuera del rango ${state.thresholdMin}-${state.thresholdMax} ${getUnit(state.metricUnit, i18n)?.short}`;
    case DeviceAlertComparisonType.Below:
      return t(i18n)`Por debajo de ${state.thresholdValue} ${getUnit(state.metricUnit, i18n)?.short}`;
    case DeviceAlertComparisonType.Above:
      return t(i18n)`Por encima de ${state.thresholdValue} ${getUnit(state.metricUnit, i18n)?.short}`;
    default:
      return t(i18n)`Desconocido (${state.comparisonType})`;
  }
};

export const alertConfigurationToString = (config: AlertConfiguration, i18n: I18n): string[] => {
  const { __typename, id, deviceId, metric, startAt, ...states } = config;
  const configString: string[] = [];
  if (metric === DeviceAlertMetricName.Intruder) {
    configString.push(t(i18n)`Alerta de intruso`);
  } else {
    Object.entries(states).filter(([_, value]) => value !== null)
      .forEach(([key, value]) => configString.push(`${key}: ${alertConfigurationStateToString(value!, i18n)}`));
  }
    return configString;
};
